import {formatISO} from '@shared/helpers/date'

import {getSaleHistoryDetailByApi, getSaleHistoryFilterByApi} from '@web/actions/saleHistory'
import makeSlice from '@web/slices/saleHistory/sliceMaker'

const saleHistorySlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(getSaleHistoryFilterByApi.fulfilled, (state, {payload}) => {
                state.statusSummaries = payload.items.map(({code, value}) => ({
                    category: code,
                    itemCount: value,
                }))
            })
            .addCase(getSaleHistoryDetailByApi.pending, (state) => {
                state.paymentDate = ''
            })
            .addCase(getSaleHistoryDetailByApi.fulfilled, (state, {payload}) => {
                const {order} = payload.detail

                state.paymentDate = formatISO(order.orderDateTime)
            })
    },
})

export default saleHistorySlice.reducer
